<div class="modal--wrap panel-show"
     ngxModalDraggable
     [expand]="false"
>
  <app-modal-header
    icon="paperclip"
    [title]="title || 'Закрепленные сообщения'"
    [modalDirective]="modalDirective"
    [bsModalRef]="bsModalRef"
    [expand]="false"
  ></app-modal-header>
  <div class="modal-body p-0">
    <div class="scroll-sidebar chat-bg" #messagesContainer>
      <div class="container-fluid pt-5 pb-4">
        <ng-template ngFor let-i="index" let-c="count" let-message [ngForOf]="messages" [ngForTrackBy]="trackByFn">
          <app-message
            [isAvatar]="true"
            [attr.id]="'message-' + message.id"
            [attr.data-id]="message.id"
            class="message message-base px-3 px-lg-6"
            [class.message-right]="message.out"
            [class.read]="message.read"
            [message]="message"
            [Service]="Service"
            [index]="i"
            [messagesContainer]="messagesContainer"
          ></app-message>
        </ng-template>
      </div>
    </div>
  </div>
</div>
